import { createAsyncThunk } from '@reduxjs/toolkit'
import { ISendMail } from './typings'
import { ServiceConfig } from '../services/config'
import { post } from '../services/crud'

const commUrl = `${ServiceConfig.baseAPIUrl}/Communication/sendMail`

export const sendMail = createAsyncThunk<boolean, ISendMail>(
  'users/sendMail',
  async (sendMail, thunkApi) => {
    const response = await post(`${commUrl}`, sendMail)
    if (response.ok) return true
    return thunkApi.rejectWithValue(await response.json())
  },
)
